import { QueryResource } from '@/lib/datx-jsonapi-react';
import { LiblynxAuthorizationGrants } from '@/resources/LiblynxAuthorizationGrants';

export const queryLiblynxAuthorizationGrants = (id: string): QueryResource<LiblynxAuthorizationGrants> => {
  return id ? [LiblynxAuthorizationGrants, id] : null;
};
